import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_PRODUCT_UOM = gql`
  mutation CreateMasterDataProductUom($params: CreateMasterDataProductUomInput!) {
    createMasterDataProductUom(params: $params) {
      uomId
      uomCode
      uomName
      uomDescription
      isLinked
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const UPDATE_MASTER_DATA_PRODUCT_UOM = gql`
  mutation UpdateMasterDataProductUom($params: UpdateMasterDataProductUomInput!) {
    updateMasterDataProductUom(params: $params) {
      uomId
      uomCode
      uomName
      uomDescription
      isLinked
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const DELETE_MASTER_DATA_PRODUCT_UOMS = gql`
  mutation DeleteMasterDataProductUoms($params: DeleteMasterDataProductUomsInput!) {
    deleteMasterDataProductUoms(params: $params) {
      deletedCount
      blockedCount
      blockedIds
      message
    }
  }
`;
